export const LogoutIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="m14.533 12.183 2.133-2.133-2.133-2.133M8.134 10.05h8.475M9.8 16.667c-3.683 0-6.666-2.5-6.666-6.667S6.117 3.333 9.8 3.333"
      stroke="#fe5058"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
